import type { DefaultDashboardDefinition } from './dashboard-definition';

export const teamDashboard: DefaultDashboardDefinition = {
  id: "configuration.team",
  appId: "configuration",
  name: "Team dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: "."
  },
  queryScope: null,
  placements: [
    {
      id: "organisation.summary.team.members",
      widgetId: "organisation.summary.team.members",
      placement: {
        x: 0,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.team.branches",
      widgetId: "organisation.summary.team.branches",
      placement: {
        x: 3,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.team.references",
      widgetId: "organisation.summary.team.references",
      placement: {
        x: 6,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.team.leaders",
      widgetId: "organisation.summary.team.leaders",
      placement: {
        x: 9,
        y: 0,
        width: 3,
        height: 1
      }
    }
  ]
};
